import { Link } from "@components/Link/Link";
import React from "react";
import tw from "twin.macro";
import { FeaturedCollectionCardProps } from "./withFeaturedCollection";
import { CustomImage } from "@bared/ui";

const Wrapper = tw.div`
  w-full cursor-pointer block
`;

const Button = tw.div`
  mt-midi font-body text-left items-center flex w-full transition-presentation group-hover:text-secondary
`;

const FeaturedCollectionCard = ({
  image,
  link,
  handlePromoClick,
}: FeaturedCollectionCardProps) => (
  <Wrapper
    className={"group"}
    as={link?.url ? Link : null}
    to={link?.url}
    onClick={() => handlePromoClick(link?.title)}
    tabIndex={0}
  >
    <CustomImage data={image} />
    <Button>{link?.title} &rarr;</Button>
  </Wrapper>
);

export default FeaturedCollectionCard;
